module.exports = __webpack_public_path__ + "static/media/correctivo_amarillo.3695e760.svg";